import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';

/** Old root layout: navbar + home carousel + Cairo fittings. */
@Component({
  selector: 'legacy-shell',
  templateUrl: './legacy-shell.component.html',
})
export class LegacyShellComponent {
  isLoggedIn: boolean = false;
  option: string = 'home';

  constructor(private auth: AuthService) {
    // the shell may be created after the session was restored, so seed from the current state
    this.isLoggedIn = !!this.auth.access_token();
    auth.onAuthChanged.subscribe(authState => {
      this.isLoggedIn = !!(authState && authState.access_token);
      if (!this.isLoggedIn) {
        this.option = 'home';
      }
    });
  }

  navigation(option: string) {
    this.option = option;
  }
}
